import React from 'react';

export default function FilterButtons(props) {
	return (
		<>
			<div className="col-2 view">
				<button
					className="btn btn-block bg-gradient-primary"
					onClick={props.handleSearch}
					type={props.type || 'button'}>
					Search
				</button>
			</div>
			<div className="col-2 view">
				<button
					className="btn btn-block bg-gradient-danger"
					onClick={props.resetFilter}
					type={props.type || 'button'}>
					Reset
				</button>
			</div>
		</>
	);
}
